import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { localize } from 'core/localization';
import { LearningObjectiveItem, ItemTitle } from './LearningObjectiveTreeNode.styled';

export default class LearningObjectiveTreeNode extends PureComponent {
  render() {
    const { onClick, isActive, onKeyDown, role, tabIndex } = this.props;
    return (
      <LearningObjectiveItem
        isActive={isActive}
        tabIndex={tabIndex}
        role={role}
        ariaLabel={localize('[overview]')}
        {...(!isActive && { onClick, onKeyDown })}
      >
        <ItemTitle>{localize('[overview]')}</ItemTitle>
      </LearningObjectiveItem>
    );
  }
}

LearningObjectiveTreeNode.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  role: PropTypes.string,
  tabIndex: PropTypes.number
};
